<template>
  <div class="address-dialog">
    <el-dialog title="常用收发通" :visible.sync="visible" :before-close="closeDialog" width="1040px" :close-on-click-modal="false">
      <!-- 搜索 -->
      <div class="mb-24">
        <el-input size="small" v-model.trim="searchValue" placeholder="请输入企业名称" style="width: 220px;margin-right: 10px;"></el-input>
        <el-button size="small" type="primary" @click="searchData">查询</el-button>
      </div>
      <!-- <el-form :inline="true">
        <el-form-item>
          <el-input size="small" v-model.trim="searchValue" placeholder="请输入企业名称" style="width: 220px;margin-right: 10px;"></el-input>

        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="searchData">查询</el-button>
        </el-form-item>
      </el-form> -->

      <div class="list">
        <div class="table-list" v-loading="loading" v-if="addressList.length > 0">
          <div class="address-content">
            <div class="address-box" :class="{active: currentIndex === index }" v-for="(item,index) in addressList" :key="index" @click="activeData(item, index)">
              <el-row :gutter="18">
                <div v-if="tabIndex == '0'">
                  <el-col :span="10">
                    <div class="cloumn">
                      <div class="title" style="font-size:16px">国家代码：</div>
                      <div class="text">{{item.countryCode}}</div>
                    </div>
                  </el-col>
                  <el-col :span="10">
                    <div class="cloumn">
                      <div class="title" style="font-size:16px">联系电话：</div>
                      <div class="text">{{item.contact}}</div>
                    </div>
                  </el-col>
                  <el-col :span="24">
                    <div class="cloumn">
                      <div class="title">企业名称：</div>
                      <div class="text txt24">{{item.customerName}}</div>
                    </div>
                  </el-col>
                  <el-col :span="24">
                    <div class="cloumn">
                      <div class="title">公司地址：</div>
                      <div class="text txt24">{{item.address}}</div>
                    </div>
                  </el-col>
                  <el-col :span="24">
                    <div class="cloumn">
                      <div class="title">实际联系人：</div>
                      <div class="text txt24">{{item.actualContactPerson||'/'}}</div>
                    </div>
                  </el-col>
                  <el-col :span="24">
                    <div class="cloumn">
                      <div class="title">联系人电话：</div>
                      <div class="text txt24">{{item.actualContactTel||'/'}}</div>
                    </div>
                  </el-col>
                </div>
                <div v-if="tabIndex == '1'">
                  <el-col :span="10">
                    <div class="cloumn">
                      <div class="title " style="font-size:16px">国家代码：</div>
                      <div class="text">{{item.countryCode}}</div>
                    </div>
                  </el-col>
                  <el-col :span="10">
                    <div class="cloumn">
                      <div class="title" style="font-size:16px">邮编：</div>
                      <div class="text">{{item.postcode}}</div>
                    </div>
                  </el-col>
                  <el-col :span="24">
                    <div class="cloumn">
                      <div class="title">企业名称：</div>
                      <div class="text txt24">{{item.customerName}}</div>
                    </div>
                  </el-col>
                  <el-col :span="24">
                    <div class="cloumn">
                      <div class="title">城市：</div>
                      <div class="text txt24">{{item.city}}</div>
                    </div>
                  </el-col>
                  <el-col :span="24">
                    <div class="cloumn">
                      <div class="title">州/省：</div>
                      <div class="text txt24">{{item.province}}</div>
                    </div>
                  </el-col>
                  <el-col :span="24">
                    <div class="cloumn">
                      <div class="title">公司地址：</div>
                      <div class="text txt24">{{item.address}}</div>
                    </div>
                  </el-col>
                  <el-col :span="24">
                    <div class="cloumn">
                      <div class="title">联系人电话：</div>
                      <div class="text txt24">{{item.actualContactTel||'/'}}</div>
                    </div>
                  </el-col>
                </div>
              </el-row>
            </div>
          </div>
          <div class="pagination" v-if="total > 0">
            <el-pagination @size-change="changePageSize" @current-change="changePage" :current-page="pageNum" :page-sizes="[10, 20, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" />
          </div>

          <!-- v-if="total > 0" -->

        </div>
        <div class="content-center" v-else>
          <el-empty image="https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/home/table-empty.png" description="无收发通记录"></el-empty>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" @click="chooseSuccess">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { httpAgent } from "@/api/ajax";

export default {
  name: "Address",
  props: {
    tabIndex: {
      type: Number,
      default: 0
    },
    visible: Boolean,
    addressType: {
      type: Number,
    }


  },
  data () {
    return {
      pageNum: 1, 
      total: 0,
      pageSize: 10,
      loading: false,
      searchValue: '', // 搜索内容
      addressList: [],
      currentIndex: '',
      currentData: '',
    }
  },
  
  created () {
    this.getList()
  },
  methods: {
    // 选择输入框
    activeData(item, index){
      this.currentIndex = index
      this.currentData = item
    },
    // 确定
    chooseSuccess(){
      this.$emit('chooseSuccess', { ...this.currentData, addressType: this.addressType })
      this.$emit('closeDialog')

    },
    // 获取数据
    getList () {
      this.loading = true
      let param = {
        type: 0,
        pageSize: this.pageSize,
        currentPage: this.pageNum,
        keyword: this.searchValue
      }
      httpAgent({
        url: `/agent/ccam/customs`,
        method: "get",
        data:param
      }).then((res) => {
        this.addressList = res.records
        // this.addressList = []
        this.total = res.total
      }).finally(() => {
        this.loading = false
      })
    },
    // 关闭
    closeDialog(){
      this.$emit('closeDialog')
    },
    // 查询数据
    searchData () {
      this.currentIndex = ''
      this.getList()
    },
    // 切换页码
    changePage (page) {
      this.currentIndex = ''
      this.pageNum = page
      this.getList()
    },
    // 切换每页数量
    changePageSize (num) {
      this.currentIndex = ''
      this.pageSize = num
      this.getList()
    },

  },
}
</script>

<style scoped lang="less">
.address-dialog {
  padding: 24px;
  background-color: white;
  box-sizing: border-box;
  height: 100%;

  .list {
    .table-list {
      overflow: hidden;
      .address-content {
        height: 500px;
        overflow: auto;
      }
      ::v-deep .el-col {
        margin-bottom: 10px;
        .title {
          font-size: 12px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #333333 !important;
        }
        .text {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #000000;
        }
      }
    }

    .address-box {
      display: inline-block;
      padding: 24px;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      cursor: pointer;
      transition: 0.3s;
      margin-bottom: 16px;

      .cloumn {
        display: flex;
        flex-direction: row;
        font-size: 13px;
        min-height: 24px;

        .title {
          width: 106px;
          color: #989898;
          text-align: right;
          font-size: 14px;
          margin-right: 8px;
        }

        .text {
          flex: 1;
          word-break: break-word;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #000000;

          &.txt24 {
            padding-right: 24px;
          }
        }
      }
    }
  }

  .active {
    border: 1px solid #1170eb !important;
  }
}
</style>